import DBOperationsComb from "src/utils/dbOperationsComb";
import Exception from "src/utils/exception";

async function getFLRAItemList(tableName, config, offlineFirst = true) {
  try {
    return await DBOperationsComb.fetchData(
      {
        tableName,
        ...config
      },
      offlineFirst
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

export default {
  getFLRAItemList
};
